/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel, HelpBlock, FormControl } from 'react-bootstrap';

import ApiDrivers from '../../Api/Drivers';
import { bsValidationState, renderFormField } from '../../helpers/forms';
import FleetSelect from '../../Fleet/FleetSelect';

const FIELDS = [
  {
    name: 'firstName',
    label: 'Primeiro Nome',
    isRequired: true,
  },
  {
    name: 'surname',
    label: 'Sobrenome',
    isRequired: true,
  },
  {
    name: 'nickname',
    label: 'Apelido',
  },
  {
    name: 'homeAddress',
    label: 'Cidade em que Vive',
    placeholder: 'Ex: SABARÁ/MG',
    isRequired: true,
  },
];

const Form = ({ ...formProps }) => {
  const {
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    onClose,
    values,
    touched,
    errors,
    status,
  } = formProps;

  return (
    <form onSubmit={handleSubmit}>
      {FIELDS.map(field => renderFormField({ field, formProps }))}

      {/* Fleet Select */}
      <FormGroup
        controlId="fleet"
        validationState={bsValidationState(touched.fleet, errors.fleet)}
      >
        <ControlLabel>
          {'Frota Atual:'}
        </ControlLabel>
        <FleetSelect
          id="fleet"
          value={values.fleet}
          onChange={value => setFieldValue('fleet', value)}
          onBlur={() => setFieldTouched('fleet', true)}
        />
        <FormControl.Feedback />
        {touched.fleet && errors.fleet && <HelpBlock><small>{errors.fleet}</small></HelpBlock>}
      </FormGroup>

      <div className="form-group form-group-button">
        <button className="button button-primary button-right" type="submit" disabled={isSubmitting}>Salvar</button>
        <button className="button button-right" type="button" onClick={onClose}>Cancelar</button>
      </div>
      {status && (
        <span>Erro inesperado: {status.error}</span>
      )}
    </form>
  );
};

const formikEnhancer = withFormik({
  mapPropsToValues: ({ driver }) => ({
    firstName: driver.firstName || '',
    surname: driver.surname || '',
    nickname: driver.nickname || '',
    homeAddress: driver.homeAddress || '',
    fleet: driver.fleet || '',
  }),

  validate: (values, props) => {
    const errors = {};
    if (!values.firstName) { errors.firstName = 'Preencha este campo'; }
    if (!values.surname) { errors.surname = 'Preencha este campo'; }
    if (!values.homeAddress) { errors.homeAddress = 'Preencha este campo'; }

    if (values.fleet && !props.fleets[values.fleet]) { errors.fleet = 'Selecione uma frota válida'; }

    return errors;
  },

  handleSubmit: async (
    values,
    {
      props,
      setSubmitting,
      setStatus,
      /* setError, setValues, setStatus, and other goodies */
    },
  ) => {
    const { driver: { id } } = props;

    // persist info
    const { status, error } = await ApiDrivers.updateOrCreateById(id, values);

    // check state
    const { CREATED, UPDATED } = ApiDrivers.Status;
    if (status === CREATED || status === UPDATED) {
      props.onClose();
    } else if (error) {
      setStatus({ error });
      setSubmitting(false);
    }
  },
});

const reduxEnhancer = connect(
  store => ({
    fleets: store.fleetState.fleets,
  }),
  null,
);

const FormContainer = reduxEnhancer(formikEnhancer(Form));

FormContainer.propTypes = {
  driver: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default FormContainer;



// WEBPACK FOOTER //
// ./src/Driver/DriverFormPopup/Form.js